import { Pie, mixins } from 'vue-chartjs';
import chartMixin from './chartMixin';
export default {
  name: 'NiotaClassicChartsPie',
  extends: Pie,
  mixins: [mixins.reactiveProp, chartMixin],
  props: {
    chartData: {
      type: Object,
      default: function () {
        return {};
      }
    },
    options: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  watch: {
    chartData: {
      handler: function () {
        this.updateBarChart();
        // this.$data._chart.update();
      },
      deep: true
    }
  },
  mounted() {
    this.updateBarChart();
  },
  methods: {
    updateBarChart() {
      let color1 = this.shadeColor(10, this.chartData.color || '#17bc00');
      let color2 = this.shadeColor(-30, this.chartData.color || '#17bc00');
      this.renderChart({
        labels: this.chartData.labels,
        datasets: [{
          backgroundColor: [color1, color2],
          data: this.chartData.data
        }]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: this.options.legend || false
        }
      });
    }
  }
};